export default [
    {
        path: "/report/canteen/dashboard",
        component: () => import("@/App/Canteen/Reports/Components/Dashboard.vue"),
        name: "report.canteen.dashboard",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/monthly-sales-purchase-profit",
        component: () => import("@/App/Canteen/Reports/Components/MonthlySalePurchase.vue"),
        name: "report.canteen.sales",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/monthly-purchase",
        component: () => import("@/App/Canteen/Reports/Components/MonthlyPurchase.vue"),
        name: "report.canteen.monthly.purchase",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/monthly-sales",
        component: () => import("@/App/Canteen/Reports/Components/MonthlySales.vue"),
        name: "report.canteen.monthly.sales",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/monthly-sales-details",
        component: () => import("@/App/Canteen/Reports/Components/MonthlySalesDetails.vue"),
        name: "report.canteen.monthly.sales.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/revenue",
        component: () => import("@/App/Canteen/Reports/Components/List.vue"),
        name: "report.canteen.revenue.monthly",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/canteen/monthly/sale-purchase",
        component: () => import("@/App/Canteen/Reports/Components/ItemRevenue.vue"),
        name: "report.canteen.item.revenue.monthly",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/monthly/category-revenue",
        component: () => import("@/App/Canteen/Reports/Components/CategoryRevenue.vue"),
        name: "report-canteen-monthly-category-revenue",
        meta: {
            requiresAuth: true,
        },
    },

    // Stock
    {
        path: "/report/canteen/stock",
        component: () => import("@/App/Canteen/Reports/Components/StockListTable.vue"),
        name: "report.canteen.inventory.stock",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/stock-demo",
        component: () => import("@/App/Canteen/Reports/Components/StockList.vue"),
        name: "report.canteen.inventory.stock.demo",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/stock-demo-table",
        component: () => import("@/App/Canteen/Reports/Components/StockListTable.vue"),
        name: "report.canteen.inventory.stock.demo.table",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/purchase-cost",
        component: () => import("@/App/Canteen/Reports/Components/PurchaseCost.vue"),
        name: "report.canteen.purchase.cost",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/production-cost",
        component: () => import("@/App/Canteen/Reports/Components/ProductionCost.vue"),
        name: "report.canteen.production",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/production-cost/:id",
        component: () => import("@/App/Canteen/Reports/Components/ProductionCostDetails.vue"),
        name: "report.canteen.production.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/day-book",
        component: () => import("@/App/Canteen/Reports/Components/DayBook.vue"),
        name: "report.canteen.daybook",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/daily-profit",
        component: () => import("@/App/Canteen/Reports/Components/DailyProfit.vue"),
        name: "report-canteen-daily-profit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/day-book-diff",
        component: () => import("@/App/Canteen/Reports/Components/DayBookDiff.vue"),
        name: "report-canteen-daybook-diff",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/users-day-book",
        component: () => import("@/App/Canteen/Reports/Components/DayBookUsers.vue"),
        name: "report.canteen.users.daybook",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/sales/:id/view",
        component: () => import("@/App/Canteen/Reports/Components/displayVoucher.vue"),
        name: "report.sale.view",
        meta: {
            requiresAuth: true,
        },
    },

    //Account Info
    {
        path: "/report/canteen/item-voucher-details",
        component: () => import("@/App/Canteen/Reports/Components/ItemsVoucherDetails.vue"),
        name: "report.canteen.product.voucher.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/items-in-out",
        component: () => import("@/App/Canteen/Reports/Components/ItemsInOut.vue"),
        name: "report.canteen.items.in.out",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/ledger",
        component: () => import("@/App/Canteen/Reports/Components/LedgerDetails.vue"),
        name: "report.canteen.LedgerDetails",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/monthly-ledger/:id",
        component: () => import("@/App/Canteen/Reports/Components/MonthlyLedger.vue"),
        name: "report-canteen-monthly-ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/yearly-ledger/:id",
        component: () => import("@/App/Canteen/Reports/Components/YearlyLedger.vue"),
        name: "report.canteen.yearly.ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/ledger-items",
        component: () => import("@/App/Canteen/Reports/Components/LedgerItemsDetails.vue"),
        name: "report.canteen.LedgerItemDetails",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/ledger-details",
        component: () => import("@/App/Canteen/Reports/Components/LedgerTransactionDetails.vue"),
        name: "report.canteen.LedgerTranDetails",
        meta: {
            requiresAuth: true,
        },
    },

    // My Bill
    {
        path: "/report/canteen/my-canteen-bill-details",
        component: () => import("@/App/Canteen/Reports/Components/MyBillDetails.vue"),
        name: "report.my.canteen.details",
        meta: {
            requiresAuth: true,
        },
    },

    //Account Group
    {
        path: "/report/canteen/group",
        component: () => import("@/App/Canteen/Reports/Components/Groups.vue"),
        name: "report.canteen.group",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/group/:id",
        component: () => import("@/App/Canteen/Reports/Components/GroupLedger.vue"),
        name: "report.canteen.group.ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/group-purchase-sale-payment",
        component: () => import("@/App/Canteen/Reports/Components/PurchaseSalesLedgerPayments.vue"),
        name: "report.canteen.purchase.sale.ledger.payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/monthly-ledge-purchase-sale-payment",
        component: () => import("@/App/Canteen/Reports/Components/MonthlySalePurchaseLedgerPayment.vue"),
        name: "report.canteen.monthly.sale.ledger.payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/group-emi",
        component: () => import("@/App/Canteen/Reports/Components/LedgerEMIDetails.vue"),
        name: "report.canteen.group.ledger.emi",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/ledger/:id",
        component: () => import("@/App/Canteen/Reports/Components/GroupLedger.vue"),
        name: "report.canteen.ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/company-wise-bill",
        component: () => import("@/App/Canteen/Reports/Components/CompanyWiseBill.vue"),
        name: "report.canteen.company.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/sms-due-list",
        component: () => import("@/App/Canteen/Reports/Components/SmsDueList.vue"),
        name: "report.canteen.sms.due.list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/officer-bill",
        component: () => import("@/App/Canteen/Reports/Components/OfficerBill.vue"),
        name: "report.canteen.officer.bill",
        meta: {
            requiresAuth: true,
        },
    },

    // Audit Section
    {
        path: "/report/canteen/audit-monthly",
        component: () => import("@/App/Canteen/Reports/Components/Audit/AuditSheetMonthly.vue"),
        name: "report.canteen.audit.monthly",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/audit-sheet-summary",
        component: () => import("@/App/Canteen/Reports/Components/Audit/DataTable.vue"),
        name: "report.canteen.audit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/audit-sheet-monthly",
        component: () => import("@/App/Canteen/Reports/Components/Audit/ReportMonthlyAuditSheet.vue"),
        name: "report.canteen.audit.monthly",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/audit-sheet/:id",
        component: () => import("@/App/Canteen/Reports/Components/Audit/AuditSheet.vue"),
        name: "report.canteen.audit.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/audit-stock",
        component: () => import("@/App/Canteen/Reports/Components/Audit/StockDataTable.vue"),
        name: "report.canteen.audit.stock",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/canteen/audit-asset",
        component: () => import("@/App/Canteen/Reports/Components/Audit/AssetDataTable.vue"),
        name: "report.canteen.audit.asset",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/canteen/audit-ledger",
        component: () => import("@/App/Canteen/Reports/Components/AuditLedgerDetails.vue"),
        name: "report.canteen.audit-ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/canteen/audit-ledger/update",
        component: () => import("@/App/Canteen/Reports/Components/AuditLedgerUpdate.vue"),
        name: "report.canteen.audit.ledger.update",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/canteen/item-demand",
        component: () => import("@/App/Canteen/Reports/Components/DemandList.vue"),
        name: "report-canteen-item-demand",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/audit/canteen/balance-sheet",
        component: () => import("@/App/Canteen/Reports/Components/BalanceSheet.vue"),
        name: "audit.canteen.sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
